export interface ReferralPriceQuote {
  amount: number;
  originalAmount: number;
  savings: number;
  discountedFeatures: string[];
}

export const getDepartmentAdjustedPricing = (
  pricing: Record<string, number | string | undefined>,
  department?: string
): Record<string, number | string | undefined> => {
  const adjustedPricing = { ...pricing };
  const normalizedDepartment = String(department || '').trim().toLowerCase();
  if (normalizedDepartment === 'commercial' || normalizedDepartment === 'art') {
    const labPrice = Number(adjustedPricing.labs || 0);
    if (Number.isFinite(labPrice) && labPrice > 0) adjustedPricing.labs = Math.round(labPrice * 35) / 100;
  }
  return adjustedPricing;
};

export const calculateReferralPrice = (
  featureKeys: string[],
  pricing: Record<string, number | string | undefined>,
  credits: Record<string, number | undefined> = {},
  discountPercent = 5
): ReferralPriceQuote => {
  let totalKobo = 0;
  let originalKobo = 0;
  const discountedFeatures: string[] = [];

  for (const featureKey of featureKeys) {
    const configuredPrice = Number(pricing[featureKey] || 0);
    const baseKobo = Number.isFinite(configuredPrice) && configuredPrice > 0
      ? Math.round(configuredPrice * 100)
      : 0;
    originalKobo += baseKobo;
    if ((Number(credits[featureKey]) || 0) > 0) {
      totalKobo += Math.round(baseKobo * (100 - discountPercent) / 100);
      discountedFeatures.push(featureKey);
    } else {
      totalKobo += baseKobo;
    }
  }

  return {
    amount: totalKobo / 100,
    originalAmount: originalKobo / 100,
    savings: (originalKobo - totalKobo) / 100,
    discountedFeatures,
  };
};